<template>
  <el-collapse :value="status < 4 ? '1' : ''">
    <el-collapse-item name="1">
      <template #title>
        <div style="margin-left: 7px;">
          <span v-if="itemPolicyType === 1 || itemPolicyType === 0">
            <i class="fa-solid fa-money-check"></i>    &nbsp; {{$t('Daxili_qiymətləndirmə')}}
        
          </span>
          
          <span v-else>
            <i class="fa-solid fa-comment-dollar"></i>     &nbsp;{{$t('Qiymətləndirmə')}}
          </span>
        </div>
      </template>
      <card>
        <!-- <div>
          <el-button size="small"  type="danger" @click="evaluationClear(1)">{{$t('Qiymətləndirməni_təmizlə')}}</el-button>
        </div> -->
        <div class="row">
          <div class="col-9"></div>
          <div class="col-3">
            <div class="text-center" :class="status ? statusColor(status) : ''">
              <span style="font-size: var(--font-primary); color: white">
                {{ item.techExpertStatusName }}
              </span>
            </div>
          </div>
        </div>
        <el-form ref="initialForm" size="small" :rules="rules" :model="item" v-loading="loading">
          <div>
            <div class="row" style="padding-bottom: 10px">
              <div class="col-md-4">
                <el-form-item :label="$t('İlkin_məbləğ')" prop="initialExpertSum">
                  <el-input disabled v-decimal v-model="item.initialExpertSum"></el-input>
                </el-form-item>
              </div>

              <div class="col-md-4">
                <el-form-item :label="$t('Qeyd')" prop="initialExpertNote">
                  <el-input v-model="item.initialExpertNote"></el-input>
                </el-form-item>
              </div>
              <div class="col-md-4" style="margin-top: 32px">
                <el-button size="small" type="primary" v-if="!readonly" style="width: 120px;"
                  @click="repairDialogVisibleInitial = true">{{$t('Ilkin_akt')}}
                </el-button>
                <el-dialog :before-close="handleUploadDoc" :title="$t('Zərər_aktı')" width="97%" top="2vh"
                  :visible.sync="repairDialogVisibleInitial" center>
                  <div v-if="item.claimId !== 0">
                    <repair-stages @initialSum="onInitialSum" :actType="1" :policyType="this.itemPolicyType"
                      :readonly="readonly" :value="item.claimId" ref="childRef"></repair-stages>
                  </div>
                </el-dialog>&nbsp;&nbsp;
                <el-button size="small" type="primary" v-if="!readonly" :disabled="saveloading" @click="save(1)">{{$t('Yadda_saxla')}}</el-button>

                <created-label v-if="item.initialExpertDateStr" :created="item.initialExpertDateStr"
                  :class="{ 'higher-position': readonly }" :type="2" />
              </div>

            </div>
          </div>
        </el-form>
        <el-form ref="finalForm" v-if="isInitialExpertSumValid" :rules="rules" :model="item">

          <hr v-if="isInitialExpertSumValid">
          <div>
            <div class="row" style="padding-bottom: 10px">
              <div class="col-md-4">
                <el-form-item :label="$t('Yekun_məbləğ')" disabled prop="finishExpertSum">
                  <el-input size="small" disabled v-decimal v-model="item.finishExpertSum"></el-input>
                </el-form-item>
              </div>

              <div class="col-md-4">
                <el-form-item :label="$t('Qeyd')" prop="finishExpertNote">
                  <el-input size="small" :readonly="status >= 2 || readonly" v-model="item.finishExpertNote"></el-input>
                </el-form-item>
              </div>
              <div class="col-md-4" style="margin-top: 44px">
                <el-button style="width: 120px;" size="small" type="primary"
                  v-if="hasRoles(['Tech expertise operator', 'Client service operator', 'Tech expertise manager'])"
                  @click="openFinishActDialog">{{$t('Yekun_akt')}}</el-button>
                <el-dialog :before-close="handleUploadDoc" :title="$t('Zərər_aktı')" width="97%" top="2vh"
                  :visible.sync="repairDialogVisibleFinal" center>
                  <div v-if="item.claimId !== 0">
                <repair-stages 
  @finishSum="onFinishSum" 
  :actType="2" 
  :readonly="readonly"
  :policyType="this.itemPolicyType" 
  :value="item.claimId"
  ref="finishRepairStages"> <!-- ref ekleyin -->
</repair-stages>
                  </div>
                </el-dialog>&nbsp;&nbsp;
                <el-button size="small" v-if="!readonly" :disabled="saveloading" type="primary" @click="save(2)">{{$t('Yadda_saxla')}}</el-button>
                <created-label v-if="item.finishExpertDateStr" :type="2" :created="item.finishExpertDateStr" />

              </div>
            </div>
          </div>
        </el-form>
        <div class="custom-upload-left">
          <dir class="col-12">
            <upload ref="upload" :key="uploadKey" :disabled="readonly" :sourcetype="9" :sourceId="item.claimId"
              :autoupload="true" :downloadAll="false"></upload>
          </dir>
        </div>
      </card>
    </el-collapse-item>
  </el-collapse>
</template>


<script>
  import ReferralCard from "../components/ReferralCard.vue";
  import CreatedLabel from "./CreatedLabel.vue";
  import Upload from "../components/Upload.vue";
  import { UpdateTechExpert, UploadServiceCenterAct, RepairStageSparePartCopy, TechExpertEvaluationClear } from "../../services/claim";
  import RepairStages from "../components/RepairStages.vue";
  export default {
    components: {
      Upload,
      RepairStages,
      CreatedLabel,
    },
    props: {
      value: Object,
      readonly: { type: Boolean, default: false },
      policyType: { type: Number, default: 0 },
    },
    data() {
      return {
        loading: false,
        saveloading: false,
        item: this.value,
        itemPolicyType: this.policyType,
        status: this.value.status,
        repairDialogVisibleInitial: false,
        repairDialogVisibleFinal: false,
        uid: this.$store.state.user.id,
        roles: this.$store.state.user.roles,
        uploadKey: 0,

      };
    },
    computed: {
      isInitialExpertSumValid() {
        return this.item.initialExpertSum && this.item.initialExpertSum !== 0;
      },
      rules() {
        return {
          initialExpertSum: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: []
            },
          ],
          finishExpertSum: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: []
            },
          ],
        }
      },
    },
    methods: {
      async evaluationClear(type) {
        let typeName = '';
        if (type === 1) {
          typeName = this.$t('Daxili_qiymətləndirməni');
        }
        this.$confirm(`${typeName} təmizləmək istəyirsiz?`, this.$t('Təsdiqləyin'), {
          cancelButtonText: "Xeyr",
          confirmButtonText: this.$t('Bəli'),
          type: "info",
        }).then(() => {
          this.loading = true;
          TechExpertEvaluationClear(this.item.claimId, type, this.uid).then((response) => {
            this.loading = false;
            if (response.data) {
              if (!response.data.isSuccess) {
                this.$message({
                  type: "error",
                  message: response.data.errors[0]
                    ? response.data.errors[0]
                    : this.$t('Səhv_əməliyyat'),
                });
              } else {
                this.$message({
                  type: "success",
                  message: this.$t('Uğurlu_əməliyyat'),
                });
                this.$nextTick(() => {
                  if (this.$refs.childRef && this.$refs.childRef.updateTableData) {
                    this.$refs.childRef.updateTableData();
                  }
                });

                this.$emit("refresh");
                this.uploadKey++;
              }
            } else {
              this.$message({
                type: "error",
                message: this.$t('Səhv_əməliyyat'),
              });
            }
          });
        });
      },
      hasRoles(requiredRoles) {
        return requiredRoles.some(role => this.roles.includes(role));
      },
      async repairStages() {
        this.repairDialogVisible = true;
      },
      onInitialSum(value) {
        this.item.initialExpertSum = value;
      },
      onFinishSum(value) {
        this.item.finishExpertSum = value;
      },
      openFinishActDialog() {
  this.$emit("refresh");
  RepairStageSparePartCopy(this.item.claimId, this.uid).then((response) => {
    this.loading = false;
    if (response.data) {
      if (!response.data.isSuccess) {
        this.$message({
          type: "error",
          message: response.data.errors[0],
        });
      } else {
        // Finish repair stages component'ini güncelle
        if (this.$refs.finishRepairStages && this.$refs.finishRepairStages.updateTableData) {
          this.$refs.finishRepairStages.updateTableData();
        }
      }
    }
  });
  this.repairDialogVisibleFinal = true;
},
      handleUploadDoc() {
        UploadServiceCenterAct(this.item.claimId, this.uid).then((response) => {
          this.loading = false;
          if (response.data) {
            if (!response.data.isSuccess) {
              this.$message({
                type: "error",
                message: response.data.errors[0],
              });
            } else {
              this.repairDialogVisibleInitial = false;
              this.repairDialogVisibleFinal = false;
            }
          } else {
            this.repairDialogVisibleInitial = false;
            this.repairDialogVisibleFinal = false;
          }
        });
      },
      statusColor(status) {
        switch (status) {
          case 1:
            return "p-2 mb-2 bg-info text-dark rounded";
          case 2:
            return "p-2 mb-2 bg-warning text-dark rounded";
          case 3:
            return "p-2 mb-2 bg-success text-dark rounded";
          case 4:
            return "p-2 mb-2 bg-danger text-dark rounded";
          default:
            return "text-default";
        }
      },
      save(stage) {
        const formRef = stage === 1 ? 'initialForm' : 'finalForm';

        this.$refs[formRef].validate((valid) => {
          if (valid) {
            this.saveloading = true;
            this.item.stage = stage;
            this.item.commandUserId = this.uid;
              console.log(this.item)
            UpdateTechExpert(this.item).then((response) => {
              this.loading = false;
              if (response.data) {
                if (!response.data.isSuccess) {
                  this.$message({
                    type: "error",
                    message: response.data.errors[0],
                  });
                } else {
                  this.$message({
                    type: "success",
                    message: this.$t('Uğurlu_əməliyyat'),
                  });
                  this.$emit("refresh");
                  setTimeout(() => {
                    this.saveloading = false;
                  }, 5000);
                }
              } else {
                this.$message({
                  type: "error",
                  message: this.$t('Səhv_əməliyyat'),
                });
              }
            });
          } else {
            return false;
          }
        });
      }
    },

    watch: {
      value() {
        this.status = this.value.status;
        this.item = this.value;
      },
      policyType() {
        this.itemPolicyType = this.policyType;
      },
    },
    mounted() {
      if (this.$refs.initialForm) {
        this.$refs.initialForm.clearValidate();
      }
      if (this.$refs.finalForm) {
        this.$refs.finalForm.clearValidate();
      }
    }
  };
</script>

<style lang="scss" scoped>
  .record-label {
    font-size: var(--font-primary);
    font-style: italic;
  }

  .higher-position {
    margin-top: -15px;
  }

  .custom-upload-left {
    margin-left: -15px;
    margin-top: -10px;
  }
</style>